import Component from 'vue-class-component';
import EdHeaderOutSession from '@/core/components/ed-header-out-session/ed-header-out-session.vue';
import { _APP_STORE } from './values/app.values';
import Vue from 'vue';
import { Provide } from 'vue-property-decorator';
import { LOADING_EVENTS, OFFLINE_MODE_EVENT } from './values/core.values';
import { ScreenProvider } from '@/shared/providers/screen.provider';
import { FileProvider } from '@/shared/providers/files.provider';
import EdSelectCustomDropdown from '@/components/form/ed-select-custom/ed-select-custom-dropdown/ed-select-custom-dropdown.vue';

@Component({
  components: {
    EdHeaderOutSession,
    EdSelectCustomDropdown,
  }
})
export default class Core extends Vue {
  loaded = false;
  loadingOverlay: boolean = false;
  
  @Provide()
  ScreenProvider = new ScreenProvider();

  @Provide()
  FileProvider = new FileProvider();

  @Provide()
  EduacAppSetLoading(value: boolean) {
    this.loadingOverlay = value;
  }

  async init() {
    await this.initSession();
    this.loaded = true;
  }

  private async initSession() {
    try {
      const $root: any = this.$root;
      this.showLoading(String(this.$t('common.applicationLoading')));
      await $root.startSession();
    } catch (e) {
      this.$EdModal.createConfirmationModal({
        title: this.$t('common.error'),
        body: this.$t('errors.networkError'),
        actions: [
          {
            label: this.$t('common.tryAgain'), action: () => window.location.reload()
          }
        ]
      });

    } finally {
      this.hideLoading();
    }

  }

  private showLoading(message : string = null) : void {
    if(this.$refs && (this.$refs as any).EdLoading) {
      (this.$refs as any).EdLoading.show(message);
    }
  }

  private hideLoading() : void {
    if(this.$refs && (this.$refs as any).EdLoading) {
      (this.$refs as any).EdLoading.hide();
    }
  }

  private setOfflineMode(status : boolean) {
    this.$store.commit(_APP_STORE.MUTATIONS.SET_OFFLINE_MODE, status);
    this.$edEventBus.$emit(OFFLINE_MODE_EVENT, status);
  }


  private checkNetworkStatus() {
    if(!navigator.onLine) {
      this.setOfflineMode(true);
    }

    window.addEventListener('online', () => {
      this.setOfflineMode(false);
    });

    window.addEventListener('offline', () => {
      this.setOfflineMode(true);
    });
  }

  created() {
    this.checkNetworkStatus();
  }

  mounted() {
    this.init();
    this.$edEventBus.$on(LOADING_EVENTS.SHOW, this.showLoading);
    this.$edEventBus.$on(LOADING_EVENTS.HIDE, this.hideLoading);
  }

  beforeDestroy() {
    this.$edEventBus.$off(LOADING_EVENTS.SHOW, this.showLoading);
    this.$edEventBus.$off(LOADING_EVENTS.HIDE, this.hideLoading);
  }
}